export function compareVersions(current: string, required: string): number {
  const normalize = (v: string): number[] => {
    return v
      .split('.')
      .map((part) => parseInt(part, 10))
      .map((num) => (Number.isNaN(num) ? 0 : num));
  };

  const a = normalize(current);
  const b = normalize(required);

  const maxLen = Math.max(a.length, b.length);
  for (let i = 0; i < maxLen; i++) {
    const av = a[i] ?? 0;
    const bv = b[i] ?? 0;
    if (av < bv) return -1;
    if (av > bv) return 1;
  }
  return 0;
}
